var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline',{staticClass:"patient-timeline"},_vm._l((_vm.events),function(event){return _c('PatientTimelineItem',{key:event.id,attrs:{"event":event}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }